import defaultAttributes from '../defaultAttributes';

const FileBarChart2 = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z',
      },
    ],
    ['polyline', { points: '14 2 14 8 20 8' }],
    ['path', { d: 'M12 18v-6' }],
    ['path', { d: 'M8 18v-1' }],
    ['path', { d: 'M16 18v-3' }],
  ],
];

export default FileBarChart2;
